<h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ "trips.activity.ferry-ticket" | translate }}</h2>

<ng-container *ngIf="form">
  <mat-dialog-content [formGroup]="form" class="dialog-content">
    <div class="grid-container">
      <!-- Departure Port -->
      <mat-form-field appearance="outline" class="span-2-cols">
        <mat-label>{{
          "trips.activity.ferry-ticket-departure-port" | translate
        }}</mat-label>
        <input matInput formControlName="departurePort" required />
                <mat-error
          *ngIf="
            form.get('departurePort')?.invalid &&
            form.get('departurePort')?.touched
          "
        >
          {{ getLabelErrorMessage('departurePort') | translate }}
        </mat-error>
      </mat-form-field>

      <!-- Departure Time -->
      <input-time
        formControlName="startTime"
        [required]="true"
        label="departure-time"
      ></input-time>

      <!-- Arrival Port -->
      <mat-form-field appearance="outline" class="span-2-cols">
        <mat-label>{{
          "trips.activity.ferry-ticket-arrival-port" | translate
        }}</mat-label>
        <input matInput formControlName="arrivalPort" required />
        <mat-error
          *ngIf="
            form.get('arrivalPort')?.invalid &&
            form.get('arrivalPort')?.touched
          "
        >
          {{ getLabelErrorMessage('arrivalPort') | translate }}
        </mat-error>
      </mat-form-field>

      <!-- Arrival Time -->
      <input-time
        formControlName="endTime"
        [required]="true"
        label="arrival-time"
      ></input-time>

      <!-- Total Price -->
      <input-monetary-amount
        appCombinedReadonly
        #totalPriceReadonly="appCombinedReadonly"
        [forbiddenRoles]="['ACCOUNTANT']"
        [forbiddenStates]="['PAID_BY_CUSTOMER']"
        [combineMode]="'AND'"
        formControlName="totalPrice"
        [required]="true"
        label="total-price"
      ></input-monetary-amount>

      <!-- Company Name -->
      <mat-form-field appearance="outline">
        <mat-label>{{
          "trips.activity.ferry-ticket-company-name" | translate
        }}</mat-label>
        <input matInput formControlName="companyName" />
      </mat-form-field>

      <!-- Advance Purchase Days -->
      <mat-form-field appearance="outline">
        <mat-label>{{ "advance-purchase-days" | translate }}</mat-label>
        <input
          matInput
          type="number"
          formControlName="advancePurchaseDays"
          [required]="true"
        />
        <mat-error
          *ngIf="
            form.get('advancePurchaseDays')?.invalid &&
            form.get('advancePurchaseDays')?.touched
          "
        >
          {{ "required-advance-purchase-days" | translate }}
        </mat-error>
      </mat-form-field>

      <!-- Notes -->
      <mat-form-field appearance="outline" class="span-3-cols">
        <mat-label>{{ "notes" | translate }}</mat-label>
        <textarea matInput formControlName="notes" rows="3"></textarea>
      </mat-form-field>

      <!-- Disclaimer -->
      <mat-form-field appearance="outline" class="span-3-cols">
        <mat-label>{{ "disclaimer" | translate }}</mat-label>
        <textarea
          matInput
          formControlName="disclaimer"
          rows="3"
          maxlength="500"
        ></textarea>
        <mat-hint
          >{{ form.get("disclaimer")?.value?.length || 0 }}/500</mat-hint
        >
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-content">
    <button mat-button (click)="cancel()">{{ "cancel" | translate }}</button>
    <button
      mat-raised-button
      color="primary"
      (click)="confirm()"
      [disabled]="!form.valid"
    >
      {{ "confirmation" | translate }}
    </button>
  </mat-dialog-actions>
</ng-container>
